import { combineReducers } from 'redux';

import details from './details';

const rootAddressReducer = combineReducers({
  details,
});

export default rootAddressReducer;
